module.exports = __webpack_public_path__ + "static/media/new_charger.71c80642.png";